//Check last bank/market element saved in the DB, if no bank/market return null
export const getDataFromDB = (urlParams) => {
  if (!urlParams || !urlParams.hasOwnProperty('value')) return null;

  const filterAndParseParameters = (parameters, type) => {
    //Filter with criteria
    const filteredParameters = parameters ? parameters.value.filter(i => i.includes(type)).pop() : null;
    //Parse url
    const lastUrlParameters = filteredParameters ? parseURLParameters(filteredParameters, type) : [];
    return lastUrlParameters.length > 0 ? lastUrlParameters.filter(e => e.key === type).pop().value : null;
  };

  const bankParameter = filterAndParseParameters(urlParams, "bank");
  let bankNoMarket = "centralbank";
  if (!!bankParameter && (bankParameter === 'jefferson' || bankParameter === 'bankcentral' || bankParameter === 'centralbank')) {
    bankNoMarket = bankParameter;
  }
  if (bankParameter === null) return null;

  return { bank: bankNoMarket, market: bankParameter };
};

export const getBankSaved = (bankFromUrl, guideBankParameters) => {
    if (window.location.search.substring(1).includes("bank")) return bankFromUrl;

    let bankFromGuide = getDataFromDB(guideBankParameters);
    if (!!bankFromGuide && !!bankFromGuide.bank) return bankFromGuide.bank;

    return bankFromUrl !== '' ? bankFromUrl : "centralbank";
};

export const getMarketSaved = (guideBankParameters) => {
  let marketFromGuide = getDataFromDB(guideBankParameters);
  if (!!marketFromGuide && marketFromGuide.market) return marketFromGuide.market;

  return 'central';
};

export const parseURLParameters = (url, type = "bank") => {
    if (!url) return [];
    const queryString = url.split('?').filter(e=>e.includes(type))[0];
    if (!queryString) {
      return [];
    }
  
    const paramsArray = queryString.split('&');
    const parameters = [];

    for (let i = 0; i < paramsArray.length; i++) {
      const param = paramsArray[i].split('=');
      let key = "";
      let value = "";
      if (param.length >= 2) {
        key = decodeURIComponent(param[0]);
        value = decodeURIComponent(param[1].split(" |")[0] || '');
      } else {
        key = decodeURIComponent(param[0]);
        value = "";
      }
      parameters.push({ key, value });
    }
    return parameters;
};